import { Button, Card, Space, Table, Tag, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { MockBanner } from '../../pages/components/MockBanner';
import { PageHeader } from '../../pages/components/PageHeader';

/** Org screen 9 — proves the vocabulary fork works. */
export function OrgInstitutionsPage() {
  return (
    <div>
      <MockBanner when="the org-console read layer" />
      <PageHeader
        title="All institutions"
        subtitle="2 schools · 1 college — same shell, forked academic spine (T-10)"
        actions={<Button type="primary" icon={<PlusOutlined />} disabled>Add an institution</Button>}
      />

      <Card size="small">
        <Table
          size="small"
          pagination={false}
          rowKey="slug"
          dataSource={ROWS}
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ padding: '8px 4px' }}>
                <Space size={16} wrap>
                  <Meta label="Session" value={record.session} />
                  <Meta label="Board" value={record.board} />
                  <Meta label="Address" value={record.address} />
                  <Meta label="Principal" value={record.principal} />
                </Space>
              </div>
            ),
          }}
          columns={[
            { title: 'Institution', dataIndex: 'name', key: 'name', render: (v: string, r) => <div><div style={{ fontWeight: 600 }}>{v}</div><Typography.Text type="secondary" style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: 11.5 }}>{r.slug}</Typography.Text></div> },
            { title: 'Type', dataIndex: 'type', key: 'type', width: 90, render: (v: string) => <Tag color={v === 'school' ? 'gold' : 'blue'}>{v}</Tag> },
            { title: 'Spine', key: 'spine', width: 260, render: (_, r) => <span style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: 11.5, color: '#5b6478' }}>{r.type === 'school' ? 'Session → Grade → Section → Subject' : 'Session → Program → Batch → Term → Course'}</span> },
            { title: 'Students', dataIndex: 'students', key: 'students', width: 100, render: (v: string) => <span style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}>{v}</span> },
            { title: 'Staff', dataIndex: 'staff', key: 'staff', width: 80 },
            { title: 'Issues', dataIndex: 'issues', key: 'issues', width: 90, render: (v: number) => v > 0 ? <Tag color="error">{v}</Tag> : <Tag color="success">Clear</Tag> },
          ]}
        />
      </Card>
    </div>
  );
}

function Meta({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div style={{ fontSize: 10.5, letterSpacing: 0.4, textTransform: 'uppercase', color: '#8a94a6', fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 12.5 }}>{value}</div>
    </div>
  );
}

const ROWS = [
  { slug: 'gw-senior', name: 'Greenwood Senior School', type: 'school', students: '2,600', staff: 140, issues: 3, session: '2026–27', board: 'CBSE', address: 'Kothrud, Pune', principal: 'R. Deshmukh' },
  { slug: 'gw-primary', name: 'Greenwood Primary School', type: 'school', students: '1,440', staff: 80, issues: 0, session: '2026–27', board: 'CBSE', address: 'Kothrud, Pune', principal: 'M. Karve' },
  { slug: 'gw-college', name: 'Greenwood College', type: 'college', students: '2,200', staff: 64, issues: 2, session: '2026–27 Sem 2', board: 'SPPU', address: 'Warje, Pune', principal: 'Dr. A. Bhide' },
];
